function Footer() {
    return (
        <div className='flex-container-row'>
            <footer className='footer'>
                <div className='footer-content'>
                    <p className='footer-content-text'>
                        Copyright © 2022 website-name All rights reserved.
                        <br/>
                        Contact: azael.zamora12@gmail.com
                    </p>
                    <a href="https://github.com/neroAzsy12" target="_blank" rel="noopener noreferrer">
                        Github
                    </a>
                </div>
            </footer>
        </div>
        
    )
}

export default Footer